import React from "react";
import PropTypes from "prop-types";
import "react-phone-input-2/lib/style.css";
import CommonModal from "./CommonModal";
import Style from "./modal.module.scss";
import { footer_web, reffPartner } from "../../locales/en";

const GocardLessInfoModal = ({ isOpen, toggle }) => {
  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={footer_web?.footerBottom?.fundTap}
      headerClassName={Style.creditModalHeader}
      modalClassName={`${Style.xeroModal} ${Style.manualUploadModal} modal-lg modal-dialog-centered`}
      bodyClassName={`${Style.manualUploadContent} modal-content border-0`}
      hideFooter
    >
      <div className="inv-upload-template flex-sm-wrap-reverse">
        <div className={Style.manul_Invoice_Submit}>
          <p>{reffPartner?.partnermanage?.GocardLessInfoModal?.text1}</p>
        </div>
      </div>
    </CommonModal>
  );
};

GocardLessInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default GocardLessInfoModal;
